import script from "./ClicksByCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./ClicksByCollection.vue?vue&type=script&setup=true&lang=js"

import "./ClicksByCollection.vue?vue&type=style&index=0&id=5edca56d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edca56d"]])

export default __exports__